<template>
  <div id="signup">
    <div class="signup-form">
      <h2>Nuevo usuario</h2>
      <form @submit.prevent="onSubmit">
        <div class="input">
          <label for="username">Username</label>
          <input id="username" v-model="username" type="text" />
        </div>
        <div class="input">
          <label for="mail">Mail</label>
          <input id="mail" v-model="mail" type="text" />
        </div>
        <div class="input">
          <label for="firstname">Firstname</label>
          <input id="firstname" v-model="firstname" type="text" />
        </div>
        <div class="input">
          <label for="lastname">Lastname</label>
          <input id="lastname" v-model="lastname" type="text" />
        </div>
        <div class="input">
          <label for="phone">Phone</label>
          <input id="phone" v-model="phone" type="text" />
        </div>
        <div class="input">
          <label for="type">User Type</label>
          <select id="type" v-model="type">
            <option value="admin">Admin</option>
            <option value="read">Read</option>
            <option value="readWrite">Read & Write</option>
          </select>
        </div>
        <div class="input">
          <label for="companyId">Company</label>
          <!-- <input
            id="companyId"
            v-model="companyId"
            type="number"
          > -->
          <v-select
            id="companyId"
            class="dropdown"
            v-model="companyId"
            :items="$store.state.companies"
            item-text="name"
            item-value="id"
            label="Company"
          />
        </div>
        <h6>
          * Pswd: Tiene que Empezar con mayuscula, incluir 4 numeros y terminar
          en un simbolo (Ej. Ejemplo1234@)
        </h6>
        <div class="input">
          <label for="password">Password</label>
          <input id="password" v-model="password" type="text" />
        </div>
        <div class="input">
          <label for="confirm-password">Confirm Password</label>
          <input id="confirm-password" v-model="confirmPassword" type="text" />
        </div>
        <div class="submit">
          <button type="submit">Submit</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: "",
      mail: "",
      type: "read",
      firstname: "",
      lastname: "",
      companyId: "",
      phone: "12345678",
      password: "",
      confirmPassword: "",
    };
  },
  methods: {
    onAddHobby() {
      const newHobby = {
        id: Math.random() * Math.random() * 1000,
        value: "",
      };
      this.hobbyInputs.push(newHobby);
    },
    onDeleteHobby(id) {
      this.hobbyInputs = this.hobbyInputs.filter((hobby) => hobby.id !== id);
    },
    onSubmit() {
      const formData = {
        username: this.username,
        mail: this.mail,
        userType: this.type,
        firstname: this.firstname,
        lastname: this.lastname,
        companyId: parseInt(this.companyId),
        phone: this.phone,
        avatar: "test",
        accountStatus: "test",
        password: this.password,
      };

      console.log(formData);
      this.$store.dispatch("signup", formData);
      this.$router.push({
        name: "Dashboard",
      });
    },
  },
};
</script>

<style scoped>
.signup-form {
  width: 400px;
  margin: 30px auto;
  border: 1px solid #eee;
  padding: 20px;
  box-shadow: 0 2px 3px #ccc;
}

.input {
  margin: 10px auto;
}

.input label {
  display: block;
  color: #4e4e4e;
  margin-bottom: 6px;
}

.input.inline label {
  display: inline;
}

.input input {
  font: inherit;
  width: 100%;
  padding: 6px 12px;
  box-sizing: border-box;
  border: 1px solid #ccc;
}

.input.inline input {
  width: auto;
}

.input input:focus {
  outline: none;
  border: 1px solid #521751;
  background-color: #eee;
}

.input select {
  border: 1px solid #ccc;
  font: inherit;
}

.hobbies button {
  border: 1px solid #521751;
  background: #521751;
  color: white;
  padding: 6px;
  font: inherit;
  cursor: pointer;
}

.hobbies button:hover,
.hobbies button:active {
  background-color: #8d4288;
}

.hobbies input {
  width: 90%;
}

.submit button {
  border: 1px solid #521751;
  color: #521751;
  padding: 10px 20px;
  font: inherit;
  cursor: pointer;
}

.submit button:hover,
.submit button:active {
  background-color: #521751;
  color: white;
}

.submit button[disabled],
.submit button[disabled]:hover,
.submit button[disabled]:active {
  border: 1px solid #ccc;
  background-color: transparent;
  color: #ccc;
  cursor: not-allowed;
}
</style>
